import { ref } from '@nuxtjs/composition-api'
import Requests from '@/api/requests'

export const useSubmitCertificatePaymentForm = (requests: Requests) => {
  const errorSubmit = ref(false)
  const timeoutSubmit = ref(false)
  const rejectSubmit = ref(false)

  const submitCertificatePaymentForm = async (payload: FormData) => {
    try {
      const certificatePaymentResponse =
        await requests.sendCertificatePaymentForm(payload)
      if (certificatePaymentResponse.data.status === 500) {
        errorSubmit.value = true
        return {
          success: false,
        }
      }
      const number =
        certificatePaymentResponse?.data?.status === 200 &&
        certificatePaymentResponse?.data?.serviceCall?.title
      return {
        number,
        success: !!number,
      }
    } catch (e) {
      if (e.code === 'ECONNABORTED' || e.code === 'ERR_NETWORK') {
        timeoutSubmit.value = true
        return {
          success: false,
        }
      }
    }
  }

  const onCloseRejectionModal = () => {
    rejectSubmit.value = false
  }

  return {
    submitCertificatePaymentForm,
    onCloseRejectionModal,
    errorSubmit,
    timeoutSubmit,
    rejectSubmit,
  }
}
